module.exports = __webpack_public_path__ + "img/be454e1.png";